<div class="py-[30px] px-[50px]">
  <ng-container *ngIf="step === 1">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-agoda-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_agoda_html_标题" | translate }}
      <!-- Connect with Agoda -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel-connect_agoda_html_说明" | translate }}
      <!-- Hostex is an official Agoda connectivity partner, so we can connect with your account reliably and securely. -->
    </div>

    <div class="text-m mt-[30px]" [innerHTML]="'channel-connect_agoda_html_说明1' | translate"></div>

    <div class="text-m mt-[30px]" [innerHTML]="'channel-connect_agoda_html_使用YCS' | translate"></div>

    <div class="mt-12 text-right">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="step = step + 1">
        {{ "channel-connect_booking_html_我明白了" | translate }}
        <!-- I understand and want to connect -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 2">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-agoda-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_agoda_html_标题" | translate }}
      <!-- Connect with Agoda -->
    </div>
    <div class="text-m mt-[30px]" [innerHTML]="'channel-connect_agoda_html_关联之前须知' | translate">
      <!-- Before you start connecting, you need to
      <span class="font-bold"
        >contact Agoda's customer service or business manager and ask them for an connection with "CM Hostex"</span
      >
      (CM = Channel Manager). They have to do some settings for your connection. After they finished, go to next step. -->
    </div>
    <div class="mt-12 text-right">
      <button class="mr-3" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="step = step + 1">
        {{ "channel-connect_agoda_html_已经设置" | translate }}
        <!-- They have set Hostex as my CM -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 3">
    <div class="text-l font-bold">
      {{ "channel-connect_agoda_html_agoda登录" | translate }}
      <!-- Enter your Agoda login -->
    </div>
    <div class="text-m mt-[30px]">
      {{ "channel-connect_agoda_html_输入email" | translate }}
      <!-- Enter the email or username you use to log in to your Agoda account. -->
    </div>
    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel-connect_agoda_html_agoda登录' | translate"
            [(ngModel)]="username" />
        </div>
      </div>
    </div>
    <div class="mt-12 text-right">
      <button class="mr-3" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzType="primary" nzSize="large" [disabled]="!username" (click)="step = step + 1">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 4">
    <div class="text-l font-bold">
      {{ "channel-connect_agoda_html_输入hotelid" | translate }}
      <!-- Enter your hotel ID or listing ID -->
    </div>
    <div class="text-m mt-[30px]">
      {{ "channel-connect_agoda_html_输入hotelid描述" | translate }}
      <!-- If you use Agoda homes, please enter your listing IDs, otherwise enter your hotel IDs. One per line, click on
      "Add" to add new lines. -->
    </div>
    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field" *ngFor="let hotel of hotelIds; first as isFirst; index as i">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row relative">
            <input
              type="text"
              nz-input
              nzSize="large"
              [placeholder]="'channel-connect_with_agoda_html_placeholder_id' | translate"
              [(ngModel)]="hotel.value" />
            <i
              *ngIf="!isFirst"
              class="cursor-pointer absolute -right-5 top-1/2 -translate-y-1/2"
              nz-icon
              nzType="minus-circle"
              nzTheme="fill"
              (click)="onRemoveHotelId(i)"></i>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <button nz-button (click)="onAddHotelId()">
            {{ "channel-connect_booking_html_添加" | translate }}
            <!-- + Add -->
          </button>
        </div>
      </div>
    </div>
    <div class="mt-12 text-right">
      <button class="mr-3" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="onNext()" [nzLoading]="loading">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </ng-container>

  <!-- @if (step === 5) {
    <host-set-pricing-ratio (onBack)="step = 4" (onNext)="onFinish()"></host-set-pricing-ratio>
  } -->
</div>
